import React from 'react';
import {
  Group,
  Header as CLHeader,
  useWindowProperties,
  H5,
} from '@qred/components-library';
import { LanguageItemHeader } from './LanguageItemHeader';
import { CountryCode } from '~/enums';
import { useAppShellContext } from '~/components/shared/Navigation/AppShell.context';
import { useAccount } from '~/hooks/useAccount';
import AccountMenu from './AccountMenu';

interface HeaderProps {
  keepDesktopStyle?: boolean;
}

const Header = ({ keepDesktopStyle }: HeaderProps) => {
  const { market } = useAccount();
  const { isMobile } = useWindowProperties();
  const isQeld = market === CountryCode.NL;
  const ctx = useAppShellContext();

  return (
    <CLHeader
      keepDesktopStyle={keepDesktopStyle}
      mt={keepDesktopStyle ? -16 : undefined}
      mb={keepDesktopStyle ? 16 : undefined}
      mx={keepDesktopStyle ? -16 : undefined}
      style={keepDesktopStyle ? { zIndex: 0 } : { zIndex: 1 }}
      qeld={isQeld}
    >
      <Group justify="space-between" align="center" mx={40} h="100%">
        <H5>{ctx.headerTitle}</H5>
        {!isMobile && (
          <Group align="center">
            {!isQeld && <LanguageItemHeader />}
            <AccountMenu />
          </Group>
        )}
      </Group>
    </CLHeader>
  );
};

export default Header;
